import gql from 'graphql-tag';

export const byNameCountFragment = gql`
  fragment byNameCountFragment on ByNameCount {
    name
    count
  }
`;
export default byNameCountFragment;
